<template>
  <div>
    <maritimeService
      :name="heading"
      subProps="Marine industry software designed to streamline operations and improve efficiency"
    />
    <v-container>
      <v-row>
        <v-col sm="12" md="7" lg="7" class="mt-sm-20">
          <v-col md="6" lg="6" sm="12" align-self="center" class="mx-auto">
            <v-img :src="require('@/assets/Energy.jpg')" class="mt-sm-20" />
          </v-col>
          <v-col>
            <div class="rowq">
              <p>
                Welcome to our cutting-edge SaaS solution designed exclusively
                for shipping companies seeking to embrace sustainability and
                reduce their carbon footprint. Our Energy Efficiency Management
                Platform empowers you to record zero carbon emission journeys
                and gain invaluable insights that not only enhance your
                environmental impact but also drive operational efficiency.
              </p>
            </div>
          </v-col>
          <br /><br />
          <h1>Key Features:</h1>
          <v-row class="pt-5">
            <v-col cols="12" md="6" lg="4" sm="12">
              <v-icon class="centered-icon" color="indigo darken-4" size="90px">
                mdi mdi-molecule-co2
              </v-icon>
              <br />
              <h3>Zero Carbon Emission Tracking:</h3>
              Seamlessly track and record your shipping journeys with zero
              carbon emissions. Our platform's advanced algorithms accurately
              calculate emissions, giving you a clear picture of your
              eco-friendly achievements.
            </v-col>

            <v-col cols="12" md="6" lg="4" sm="12">
              <v-icon class="centered-icon" color="indigo darken-4" size="90px">
                mdi mdi-lightbulb-on
              </v-icon>
              <br />
              <h3>Actionable Insights:</h3>
              Harness the power of data with our platform's comprehensive
              insights. Identify areas for improvement, optimize routes, and
              make informed decisions to further enhance your energy efficiency
              efforts.
            </v-col>

            <v-col cols="12" md="6" lg="4" sm="12">
              <v-icon class="centered-icon" color="indigo darken-4" size="90px">
                mdi mdi-chart-areaspline
              </v-icon>
              <br />
              <h3>Performance Analytics:</h3>
              Dive into detailed performance analytics that showcase your
              company's commitment to sustainability. Monitor your progress over
              time and demonstrate your environmental achievements to
              stakeholders.
            </v-col>

            <v-col cols="12" md="6" lg="4" sm="12">
              <v-icon class="centered-icon" color="indigo darken-4" size="90px">
                mdi mdi-monitor-dashboard
              </v-icon>
              <br />
              <h3>Customizable Dashboards:</h3>
              Tailor your dashboard to display the metrics that matter most to
              your company. With intuitive visualization tools, you can easily
              interpret data and drive positive change.
            </v-col>

            <v-col cols="12" md="6" lg="4" sm="12">
              <v-icon class="centered-icon" color="indigo darken-4" size="90px">
                mdi mdi-account-group
              </v-icon>
              <br />
              <h3>Collaborative Platform:</h3>
              Foster collaboration among your team members with user-friendly
              features that encourage sharing ideas, strategies, and best
              practices for reducing carbon emissions.
            </v-col>

            <v-col cols="12" md="6" lg="4" sm="12">
              <v-icon class="centered-icon" color="indigo darken-4" size="90px">
                mdi mdi-chart-timeline-variant
              </v-icon>
              <br />
              <h3>Real-time Monitoring:</h3>
              Stay up-to-date with real-time monitoring of your fleet's energy
              efficiency. Receive alerts and notifications to address deviations
              from your eco-friendly goals.
            </v-col>
          </v-row>
          <v-col>
            <div class="rowq ">
              <h2>Benefits:</h2>
              <ul>
                <li>
                  <b>Environmental Leadership:</b> Showcase your commitment to
                  sustainable shipping practices and differentiate your company
                  as an industry leader in environmental responsibility.
                </li>
                <br />
                <li>
                  <b>Operational Savings:</b> By optimizing routes and enhancing
                  energy efficiency, you'll experience cost savings through
                  reduced fuel consumption and improved resource allocation.
                </li>
                <br />
                <li>
                  <b>Stakeholder Engagement:</b> Engage investors, customers,
                  and partners by transparently demonstrating your dedication to
                  environmental conservation and social responsibility.
                </li>
                <br />
                <li>
                  <b>Regulatory Compliance:</b> Stay ahead of evolving
                  environmental regulations with accurate emission tracking and
                  documentation.
                </li>
                <br />
                <li>
                  <b>Join the Movement:</b> Embrace a greener future for your
                  shipping company. With our Energy Efficiency Management
                  Platform, you're not just reducing emissions - you're shaping
                  a more sustainable world for generations to come.
                </li>
                <br />
                <li>
                  <b>Get Started Today:</b> Transform your shipping operations
                  and lead the way towards zero carbon emissions. Request a demo
                  or get in touch with our team to explore how our platform can
                  revolutionize your company's energy efficiency journey.
                </li>
              </ul>
              <br /><br />
              <p>
                Feel free to adjust and personalize this content to match your
                brand's voice and the specific features of your SaaS product.
              </p>
            </div>
          </v-col>
        </v-col>

        <v-col sm="12" md="5" lg="5">
          <base-request />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import maritimeService from "../../components/maritime-service.vue";
export default {
  components: {
    maritimeService
  },

  data: () => ({ heading: "" }),
  mounted() {
    this.heading =
      "Energy Efficiency Management Platform for Shipping Companies";
  }
};
</script>
<style scoped>
.rowq {
  text-align: justify;
}
@media (max-width: 960px) {
  .mt-sm-20 {
    margin-top: 150px;
    padding: 25px;
  }
}

@media (max-width: 800px) {
  .mt-sm-20 {
    margin-top: 140px;
    padding: 25px;
  }
}

@media (max-width: 600px) {
  .mt-sm-20 {
    margin-top: 155px;
    padding: 25px;
  }
}

@media (max-width: 500px) {
  .mt-sm-20 {
    margin-top: 200px;
    padding: 25px;
  }
}

@media (max-width: 400px) {
  .mt-sm-20 {
    margin-top: 220px;
    padding: 25px;
  }
}
</style>
